/**
 * 退款
 */
import UltMeta, { Meta } from "./UltMeta/index";

class RefundState extends UltMeta {
    AWAITING_REVIEW = new Meta(1, "待审核");
    // AWAITING_REFUND = new Meta(2, "待退款");
    REJECTED = new Meta(3, "已驳回");
    REFUNDED = new Meta(4, "已退款");
}
export const REFUND_STATE = new RefundState();
